import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const createBanner = (_, params) => {
    return Api(endPoints.banner, params, requestType.POST);
};

const getBanner = (search) => {
    const queryParams = new URLSearchParams();
    if (search) queryParams.append("search", search);

    const finalUrl = queryParams.toString() ? `${endPoints.banner}?${queryParams.toString()}` : endPoints.banner;
    return Api(finalUrl, null, requestType.GET);
};

const updateBanner = (id, params) => {
    return Api(`${endPoints.banner}/${id}`, params, requestType.PUT);
};

const deleteBanner = (id) => {
    return Api(`${endPoints.banner}/${id}`, null, requestType.DELETE);
};


export { createBanner, getBanner, updateBanner, deleteBanner };
